{
  "NTServiceForms": {
    "fields": {
      "travelingWithAssistant": {
        "note": "Travelling with your own assistant is required if you need help taking medication, eating, using the toilet, standing up yourself, fitting an oxygen mask, or if you're unable to communicate about safety matters with our cabin crew."
      }
    },
    "specialAssistanceForm": {
      "additionalInformation": {
        "note": "Please note that we will not respond to inquiries related to other topics than special assistance and/or medical conditions via this form."
      },
      "consentToProcessingMedicalData": "By submitting this form, you give us your consent to process your medical data to handle and complete your service request. The consent also applies to our partners, if necessary.",
      "fileUploader": {
        "note": "Please attach the required additional files below before submitting your request (according to your reason for special assistance request marked above)."
      }
    }
  }
}
